export const measureUnits = {
  meters: {
    text: 'м',
    html: 'м',
    label: 'Длина',
  },
  squareMeters: {
    text: 'м2',
    html: 'м<sup><small>2</small></sup>',
    label: 'Площадь',
  },
  cubicMeters: {
    text: 'м3',
    html: 'м<sup><small>3</small></sup>',
    label: 'Объем',
  },
  tons: {
    text: 'т',
    html: 'т',
    label: 'Масса',
  },
  kilos: {
    text: 'кг',
    html: 'кг',
    label: 'Масса',
  },
}

export const measureUnitsListed = () => {
  const list = []
  Object.keys(measureUnits).forEach((key) => {
    const item = measureUnits[key]
    list.push({
      value: key,
      text: item.html,
    })
  })
  return list
}

export const getMeasureUnitHtml = unit => measureUnits[unit]?.html
